import axios from 'axios'

import { getAuthHeader } from '../headers'

// ===================================================================================
//  GET TRAINING
// ===================================================================================
export const trainingIsLoading = () => {
	return {
		type: 'TRAINING_ARE_LOADING',
	}
}

export const trainingHasError = err => {
	return {
		type: 'TRAINING_HAS_ERROR',
		hasErrored: true,
		error: err,
	}
}

export const trainingSuccess = data => {
	return {
		type: 'TRAINING_SUCCESS',
		data,
	}
}

export function getTraining(id = null, isAdmin = false, num = null) {
	return (dispatch, getState) => {
		dispatch(trainingIsLoading())

		const params = num === null ? {} : { num }

		// Add id of record to find if passed
		const endPoint = 'training' + (id ? `/${id}` : '')

		return axios
			.get(process.env.REACT_APP_API_URL + endPoint, {
				headers: getAuthHeader(getState().user, isAdmin),
				params,
			})
			.then(response => {
				if (response.data.status && response.data.status !== 200) {
					dispatch(trainingHasError(response.data.errors))
				} else {
					return dispatch(trainingSuccess(response))
				}
			})
			.catch(err => {
				dispatch(trainingHasError(err.response.data.message))
			})
	}
}



// WEBPACK FOOTER //
// ./src/store/actions/training.js